//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <svg
    width="100px"
    height="100px"
    viewBox="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>zoom icon</title>
    <g
      id="zoom-icon"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Group" transform="translate(10.000000, 13.000000)">
        <circle
          id="Oval"
          stroke="#5D5D5D"
          stroke-width="5"
          :style="{ fill: store.state.Style.themeColor }"
          transform="translate(33.000000, 33.000000) rotate(-50.000000) translate(-33.000000, -33.000000) "
          cx="33"
          cy="33"
          r="23"
        ></circle>
        <g
          id="Group-2"
          transform="translate(21.000000, 20.000000)"
          fill="#5D5D5D"
        >
          <rect id="Rectangle" x="0" y="10" width="25" height="6" rx="3"></rect>
          <rect
            id="Rectangle-Copy"
            transform="translate(12.500000, 13.000000) rotate(-270.000000) translate(-12.500000, -13.000000) "
            x="0"
            y="10"
            width="25"
            height="6"
            rx="3"
          ></rect>
        </g>
        <path
          d="M49.2570649,46.7244784 C50.7319308,44.9904697 53.3264831,44.7635986 55.0799136,46.2153206 L77.4342162,64.7231737 C79.1578674,66.1502405 79.3982965,68.7044021 77.9712297,70.4280533 C77.959798,70.4418609 77.9482747,70.4555925 77.9366607,70.4692472 C76.4617948,72.2032558 73.8672424,72.430127 72.1138119,70.978405 L49.7595094,52.4705518 C48.0358582,51.043485 47.795429,48.4893235 49.2224958,46.7656723 C49.2339276,46.7518647 49.2454509,46.7381331 49.2570649,46.7244784 Z"
          id="Rectangle"
          fill="#5D5D5D"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
